import { render, staticRenderFns } from "./Actualite.vue?vue&type=template&id=083e23fd&"
import script from "./Actualite.vue?vue&type=script&lang=js&"
export * from "./Actualite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports